module.exports = __webpack_public_path__ + "static/media/typeCVersion1.ac47719b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/landing/typeCVersion1.png
// module id = 1250
// module chunks = 0